import { useProfile } from "../components/ProfileContext";
import { Row, Col, Button, Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router";
import { User } from "../models/User";
import { PersonFill } from "react-bootstrap-icons";
import { ProfileActiveJobDisplay } from "./ProfileActiveJobDisplay";
import { ProfileNavDropDown } from "./ProfileNavDropdown";
import mcelroy_logo from "../images/mcelroy_logo.png"

export function ProfileBar(props) {
	let [profile, setProfile] = useProfile();

    return (
        // <div className="profile-bar mt-0 navbar navbar-default sticky-top bg-dark text-dark" style={{textAlign:"right"}}>
        <div className="topNav sticky-top" >
			<div style={{width:"100%"}} className="mx-2">
            {(profile == null) && <div className="not-logged-in">
                Not Logged In
                <Button variant="success" className="m-2" size="sm" onClick={login}>Login</Button>
            </div>}

			{/* <ProfileActiveJobDisplay className="mx-2" /> */}
            <div className="topMenu">
            <div>
                {(profile != null) && <div><ProfileNavDropDown showFullName={false}  /></div>}
            </div>

            <div className="mcelroyLogo"><img src={mcelroy_logo}/></div>
            </div>
            

            
           </div>
        </div>
    );

}